import { OfferingType, OfferingTypeKeys, PietraPlanModuleCard, PietraPlanModuleType } from '../types/subscription';

import { StoreModuleItem } from '@/lib/service/pietra-v2';

export const OFFERINGS: OfferingType[] = [
  {
    key: OfferingTypeKeys.BUSINESS_PLAN,
    icon: '/images/subscription/plan.png',
    title: 'Get your own personalized business plan.',
    description: [
      'Pietra gives you a personalized business plan that you can work through, step-by-step, to launch your business.',
      'Get access to workshops, get supplier recommendations, and even finance your first production run.',
    ],
  },
  {
    key: OfferingTypeKeys.SOURCING,
    icon: '/images/subscription/factory.png',
    title: 'Find new suppliers and manage existing suppliers all in one place.',
    description: [
      'Work with 400+ vetted premium suppliers or invite your own suppliers to manage all your production in one place.',
      'Search by different kinds of suppliers you want to work with, like Sustainable, Luxury, and Made in USA.',
    ],
  },
  {
    key: OfferingTypeKeys.FULFILLMENT,
    icon: '/images/subscription/orders.png',
    title: 'Access low-cost order fulfillment, storage, and assembly.',
    description: [
      "Save months setting up your warehouse and use Pietra's low cost fulfillment center. Send everything to Pietra and we'll assembly your final product and packaging over zoom and ship it to your customers for you.",
      'Fulfillment rates start as low as $1.50/order.',
    ],
  },
  {
    key: OfferingTypeKeys.SALES_CHANNELS,
    icon: '/images/subscription/cart.png',
    title: 'Set up & manage multiple sales channels.',
    description: [
      'Create a free website with Pietra or connect an existing Shopify account to order fulfllment.',
      'You can also sell your products on Instagram Shopping, Verishop Marketplace & more, in a few clicks.',
    ],
  },
];

export const PLAN_MODULE_CARDS: PietraPlanModuleCard[] = [
  {
    moduleType: PietraPlanModuleType.SOURCING,
    icon: '/images/blueprint/plan-modules/sourcing.png',
    description: 'A marketplace of 1300+ products, packaging, and services suppliers.',
    benefit: 'Compare to agencies @ $5k/mo',
    moduleAttributes: [
      'Access to 1,200+ suppliers',
      'Unlimited custom project requests',
      'Unlimited sourcing projects',
      "Secure int'l payments & access to order insurance",
    ],
  },
  {
    moduleType: PietraPlanModuleType.PRODUCT_DESIGN,
    icon: '/images/blueprint/plan-modules/product-design.png',
    description: 'Creative tools to bring product ideas to life.',
    benefit: 'Compare to Adobe @ $49/mo',
    moduleAttributes: ['Unlimited AI generations', 'Unlimited custom project requests', 'Unlimited sourcing projects'],
  },
  {
    moduleType: PietraPlanModuleType.SALES_CHANNELS,
    icon: '/images/blueprint/plan-modules/sales-channels.png',
    description: 'List on multiple sales channels and let Pietra ship to your customers.',
    benefit: 'Compare to ChannelAdvisor @ $2K/mo',
    moduleAttributes: ['Listing fees: $0', 'Pietra fee: 1%'],
  },
  {
    moduleType: PietraPlanModuleType.DATA_AND_ANALYTICS,
    icon: '/images/blueprint/plan-modules/data-analytics.png',
    description: '35+ business dashboards to understand your business.',
    benefit: 'Compare to RetentionX @ $100/mo',
    lastAtrrHideMark: true,
    moduleAttributes: [
      'Free for first 100 customers',
      '35+ business dashboards',
      'Up to 2000 customers/month',
      'White glove onboarding & support',
      '*Contact for custom pricing',
    ],
  },
  {
    moduleType: PietraPlanModuleType.MARKETING_TOOLS_EMAIL,
    icon: '/images/blueprint/plan-modules/email.png',
    description: 'Build your email list from website visitors.',
    benefit: 'Compare to Retention.com @ $500/mo',
    lastAtrrHideMark: true,
    moduleAttributes: [
      '50 emails free',
      '$19/mo + 0.16c/email up to 250/mo',
      '$50/mo + 0.16c/email up to 1k/mo',
      '$300/mo + 0.15c/email up to 2k/mo',
      'White glove onboarding & support',
      '*Contact for custom pricing',
    ],
  },
  {
    moduleType: PietraPlanModuleType.MARKETING_TOOLS_SMS,
    icon: '/images/blueprint/plan-modules/sms.png',
    description: 'AI powered SMS platform with your own biz number.',
    benefit: 'Compare to Attentive @ $49/mo',
    lastAtrrHideMark: true,
    moduleAttributes: [
      'Free business phone number',
      'Unlimited AI content generations',
      '1000 texts / month',
      '+ 0.02 additional text over 1000',
      'White glove onboarding & support',
      '*Contact for custom pricing',
    ],
  },
  {
    moduleType: PietraPlanModuleType.MARKETING_TOOLS_AFFILIATE,
    icon: '/images/blueprint/plan-modules/affiliate.png',
    description: 'Set up and run an influencer marketing program.',
    benefit: 'Compare to Refersion @ $119/mo',
    moduleAttributes: [
      'Website to sign up influencers',
      'Custom link tracking for sales',
      'Unlimited offers and orders',
      'White glove obboarding',
    ],
  },
  {
    moduleType: PietraPlanModuleType.STOREFRONT,
    icon: '/images/blueprint/plan-modules/storefront.png',
    description: 'Software to grow and operate a business efficiently.',
    benefit: 'Compare to Shopify @ $79/mo',
    moduleAttributes: [
      'Free website hosting',
      '5% payment processing fee (unlimited transactions)',
      'Create unlimited discounts on storefront',
      'Wholesale capability',
    ],
  },
  {
    moduleType: PietraPlanModuleType.PREMIUM_ORDER_FULFILLMENT,
    icon: '/images/blueprint/plan-modules/premium-order-fulfillment.png',
    description: 'Store and ship inventory around the world (> 2000/mo)',
    benefit: 'Compare to Shipbob @ $400/mo',
    moduleAttributes: [
      'ALL storage & order fulfillment features',
      '$1.50/order fulfillment (unlimited picks)',
      'Priority fulfillment support',
    ],
    link: {
      url: '/platform/logistics-and-fulfillment',
      text: 'Calculate your savings now',
    },
  },
  {
    moduleType: PietraPlanModuleType.ORDER_FULFILLMENT,
    icon: '/images/blueprint/plan-modules/order-fulfillment.png',
    description: 'Infrastructure to store and ship products around the world.',
    benefit: 'Compare to Shipmonk @ $250/mo',
    moduleAttributes: [
      '$1/bin/sku storage space (secured for 12 mo)',
      '$1.50/order fulfillment (unlimited picks)',
      'White glove onboarding with warehouse support',
    ],
    link: {
      url: '/platform/logistics-and-fulfillment',
      text: 'Calculate your savings now',
    },
  },
  {
    moduleType: PietraPlanModuleType.BUSINESS_PLANNING_TOOLS,
    icon: '/images/blueprint/plan-modules/business-planning.png',
    description: 'Interactive step-by-step guide for launching an e-comm brand.',
    benefit: 'Free with membership',
    moduleAttributes: ['Unlimited projects', '$100+ in discounts and rewards'],
  },
  {
    moduleType: PietraPlanModuleType.PRINT_ON_DEMAND,
    icon: '/images/blueprint/plan-modules/print-on-demand.png',
    description: 'Make merch and promotional products at discounted rates.',
    benefit: 'Free with membership',
    moduleAttributes: ['1000+ customizable items', 'Print on demand storefront', 'Unlimited designs'],
  },
  {
    moduleType: PietraPlanModuleType.WEEKLY_WORKSHOPS,
    icon: '/images/blueprint/plan-modules/weekly-workshops.png',
    description: 'Get access to weekly workshops to learn how to use Pietra.',
    benefit: 'Free with membership',
    moduleAttributes: ['Weekly workshops', '1:1 professional support'],
  },
  // NOTE: Listed below are the 5 bundle options.
  {
    moduleType: PietraPlanModuleType.BEGINNER_BUNDLE,
    icon: '/images/blueprint/plan-modules/beginner-bundle.png',
    description: 'Launch & operate an e-commerce business.',
    moduleAttributes: [
      'Personalized AI Business Partner',
      'Access to Print On Demand & factory sourcing',
      'Access to Pietra Fulfillment Center',
      'AI Content Creation Studio',
      'Social media & ads monitoring',
      'Retail buyer outreach',
      'Hire influencers & manage affiliate programs',
    ],
    attributeHeader2: 'E-Commerce Marketing Platform',
    moduleAttributes2: [
      'Track your niche & competitors on social media',
      'Identify & contact buyers in physical retail',
      'Automatically detect email addresses of site visitors',
      'Manage your influencer marketing program',
      'Understand your customers with advanced analytics',
    ],
    bundledModuleTypes: [
      PietraPlanModuleType.PRINT_ON_DEMAND,
      PietraPlanModuleType.BUSINESS_PLANNING_TOOLS,
      PietraPlanModuleType.WEEKLY_WORKSHOPS,
      PietraPlanModuleType.PRODUCT_DESIGN,
      PietraPlanModuleType.SOURCING,
      PietraPlanModuleType.ORDER_FULFILLMENT,
      PietraPlanModuleType.STOREFRONT,
      PietraPlanModuleType.MARKETING_TOOLS_EMAIL,
      PietraPlanModuleType.MARKETING_TOOLS_AFFILIATE,
      PietraPlanModuleType.DATA_AND_ANALYTICS,
      PietraPlanModuleType.SALES_CHANNELS,
    ],
  },
  {
    moduleType: PietraPlanModuleType.PROFESSIONAL_BUNDLE,
    icon: '/images/blueprint/plan-modules/professional-bundle.png',
    description: 'Improved features & rates for scaling businesses.',
    attributeHeader: 'Everything in Pietra Essentials and...',
    moduleAttributes: [
      'Better rates in fulfillment',
      'Managed returns, exchanges, & customer support',
      'Access additional factory contact information',
      '10 team seats',
      'Increased usage rates for all AI tools',
      'Premium Pietra phone support',
    ],
    bundledModuleTypes: [
      PietraPlanModuleType.PRINT_ON_DEMAND,
      PietraPlanModuleType.BUSINESS_PLANNING_TOOLS,
      PietraPlanModuleType.WEEKLY_WORKSHOPS,
      PietraPlanModuleType.PRODUCT_DESIGN,
      PietraPlanModuleType.SOURCING,
      PietraPlanModuleType.PREMIUM_ORDER_FULFILLMENT,
      PietraPlanModuleType.STOREFRONT,
      PietraPlanModuleType.MARKETING_TOOLS_EMAIL,
      PietraPlanModuleType.MARKETING_TOOLS_AFFILIATE,
      PietraPlanModuleType.DATA_AND_ANALYTICS,
      PietraPlanModuleType.SALES_CHANNELS,
    ],
  },
  {
    moduleType: PietraPlanModuleType.CUSTOM,
    icon: '/images/blueprint/plan-modules/professional-bundle.png',
    description: 'Configured & priced for your unique business.',
    attributeHeader: 'Everything in Pietra Business and...',
    moduleAttributes: [
      'A team of account managers',
      'White glove sourcing & manufacturing',
      'White glove fulfillment onboarding & ongoing support',
      'Custom rates on AI usage & Pietra services',
    ],
    bundledModuleTypes: [
      PietraPlanModuleType.PRINT_ON_DEMAND,
      PietraPlanModuleType.BUSINESS_PLANNING_TOOLS,
      PietraPlanModuleType.WEEKLY_WORKSHOPS,
      PietraPlanModuleType.PRODUCT_DESIGN,
      PietraPlanModuleType.SOURCING,
      PietraPlanModuleType.PREMIUM_ORDER_FULFILLMENT,
      PietraPlanModuleType.STOREFRONT,
      PietraPlanModuleType.MARKETING_TOOLS_EMAIL,
      PietraPlanModuleType.MARKETING_TOOLS_AFFILIATE,
      PietraPlanModuleType.DATA_AND_ANALYTICS,
      PietraPlanModuleType.SALES_CHANNELS,
    ],
  },
  {
    moduleType: PietraPlanModuleType.LAUNCH_BUNDLE,
    icon: '/images/blueprint/plan-modules/launch-bundle.png',
    description: 'Sourcing & fulfillment for your business.',
    moduleAttributes: [
      'Unlimited product designs',
      'Access to 1,200+ suppliers',
      'Print on demand merch with a Pietra Shop',
      'Storage & fulfillment',
      'Shopify, Wix, WooCommerce, and TikTok Shop integrations',
    ],
    bundledModuleTypes: [
      PietraPlanModuleType.PRINT_ON_DEMAND,
      PietraPlanModuleType.BUSINESS_PLANNING_TOOLS,
      PietraPlanModuleType.WEEKLY_WORKSHOPS,
      PietraPlanModuleType.PRODUCT_DESIGN,
      PietraPlanModuleType.SOURCING,
      PietraPlanModuleType.STOREFRONT,
      PietraPlanModuleType.ORDER_FULFILLMENT,
    ],
  },
  {
    moduleType: PietraPlanModuleType.DESIGN_AND_SAMPLE_BUNDLE,
    icon: '/images/blueprint/plan-modules/design-sample-bundle.png',
    description: 'Design and source custom products for your business.',
    moduleAttributes: [
      'Unlimited product designs',
      'Access to 1,200+ suppliers',
      'Print on demand merch with a Pietra Shop',
    ],
    bundledModuleTypes: [
      PietraPlanModuleType.PRINT_ON_DEMAND,
      PietraPlanModuleType.BUSINESS_PLANNING_TOOLS,
      PietraPlanModuleType.WEEKLY_WORKSHOPS,
      PietraPlanModuleType.PRODUCT_DESIGN,
      PietraPlanModuleType.SOURCING,
    ],
  },
  {
    moduleType: PietraPlanModuleType.GROW_BUNDLE,
    icon: '/images/blueprint/plan-modules/grow-bundle.png',
    description: 'Essential marketing & analytics tools',
    moduleAttributes: ['Sell on TikTok Shopping', '40+ analytics dashboards', 'Influencer management & payment'],
    bundledModuleTypes: [
      PietraPlanModuleType.PRINT_ON_DEMAND,
      PietraPlanModuleType.BUSINESS_PLANNING_TOOLS,
      PietraPlanModuleType.WEEKLY_WORKSHOPS,
      PietraPlanModuleType.MARKETING_TOOLS_EMAIL,
      PietraPlanModuleType.MARKETING_TOOLS_AFFILIATE,
      PietraPlanModuleType.SALES_CHANNELS,
      PietraPlanModuleType.DATA_AND_ANALYTICS,
    ],
  },
];

export const BUNDLE_STORE_MODULE_TYPES: PietraPlanModuleType[] = [
  PietraPlanModuleType.BEGINNER_BUNDLE,
  PietraPlanModuleType.PROFESSIONAL_BUNDLE,
  PietraPlanModuleType.CUSTOM,
];

export const CUSTOM_BUNDLE_INFO: Partial<StoreModuleItem> = {
  id: 'custom',
  name: PietraPlanModuleType.CUSTOM,
  title: 'Pietra Plus',
};

export const AI_CREDITS_OPTIONS: Record<
  PietraPlanModuleType.BEGINNER_BUNDLE | PietraPlanModuleType.PROFESSIONAL_BUNDLE | PietraPlanModuleType.CUSTOM,
  number[]
> = {
  [PietraPlanModuleType.BEGINNER_BUNDLE]: [1000, 2000, 3500, 7000, 10000],
  [PietraPlanModuleType.PROFESSIONAL_BUNDLE]: [5000, 8000, 15000, 30000, 50000],
  [PietraPlanModuleType.CUSTOM]: [25000, 50000, 100000, 200000, 500000],
};
